import http from '../utils/request'

/**
 * 公告接口 — 对应后端 AnnouncementController (/api/announcement)
 */

/** 获取公告列表 */
export const getAnnouncementList = (searchText) =>
  http.get('/announcement', { params: { searchText } })

/** 获取单条公告 */
export const getAnnouncement = (guid) =>
  http.get(`/announcement/${guid}`)

/** 新增公告 */
export const createAnnouncement = (data) =>
  http.post('/announcement', data)

/** 更新公告 */
export const updateAnnouncement = (guid, data) =>
  http.put(`/announcement/${guid}`, data)

/** 删除公告 */
export const deleteAnnouncement = (guid) =>
  http.delete(`/announcement/${guid}`)

/** 发布公告 */
export const publishAnnouncement = (guid) =>
  http.put(`/announcement/${guid}/publish`)

/** 取消发布 */
export const unpublishAnnouncement = (guid) =>
  http.put(`/announcement/${guid}/unpublish`)

/** 获取公告权限列表 */
export const getAnnouncementPermissions = (guid) =>
  http.get(`/announcement/${guid}/permissions`)

/** 保存公告权限 */
export const saveAnnouncementPermissions = (guid, permissions) =>
  http.post(`/announcement/${guid}/permissions`, permissions)

/** 获取所有公告权限列表（权限管理页面） */
export const getAllAnnouncementPermissions = () =>
  http.get('/announcement/all-permissions')

/** 删除单条权限记录 */
export const deleteAnnouncementPermission = (guid) =>
  http.delete(`/announcement/all-permissions/${guid}`)
